import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StubClickDirective } from './directives/stub-click.directive';
import { LoadingComponent } from './components/loading';
import { FileDragNDropDirective } from './directives/filr-drop.directive';

@NgModule({
  declarations: [StubClickDirective, LoadingComponent, FileDragNDropDirective],
  imports: [
    CommonModule
  ],
  exports: [StubClickDirective, LoadingComponent, FileDragNDropDirective]
})
export class UtilsModule { }
